import { z } from "zod";

import { deploymentEnvironmentValidation, isMaintenanceModeValidation, urlValidator } from "../_utils.js";

/**
 * Schema für alle PUBLIC_* (Client-) Umgebungsvariablen.
 * Einzige Quelle für Frontend/Web-App; wird in client.ts und environment.ts verwendet.
 *
 * Leere Env-Strings: `createEnv({ emptyStringAsUndefined: true })` — keine `preprocess` für `"" → undefined`.
 */

export const clientSchema = {
  PUBLIC_APP_NAME: z.string().min(1),
  PUBLIC_BACKEND_URL: urlValidator,
  PUBLIC_DEFAULT_DEV_TEST_EMAIL: z.email().optional(),
  PUBLIC_DEPLOYMENT_ENVIRONMENT: deploymentEnvironmentValidation,
  PUBLIC_DOMAIN: z.string().min(1),
  PUBLIC_FIREBASE_APP_ID: z.string().min(1),
  PUBLIC_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  PUBLIC_FIREBASE_API_KEY: z.string().min(1),
  PUBLIC_FIREBASE_MEASUREMENT_ID: z.string().min(1).optional(),
  PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  PUBLIC_FIREBASE_PROJECT_ID: z.string().min(1),
  PUBLIC_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  PUBLIC_FIREBASE_VAPID_KEY: z.string().min(1),
  PUBLIC_WEBAPP_IS_IN_MAINTENANCE_MODE: isMaintenanceModeValidation,
  PUBLIC_WEBAPP_IS_REQUEST_BATCHING_DISABLED: z.enum(["true", "false"]).transform((value) => value === "true"),
  PUBLIC_WEBAPP_PORT: z.coerce.number().int().min(1).max(65535).optional(),
  PUBLIC_WEBAPP_RESEND_EMAIL_CONFIRMATION_TIMEOUT_IN_SECONDS: z.coerce.number().int().min(1).max(3600),
  PUBLIC_WEBAPP_TRPC_LOGGER_IS_DISABLED: z.enum(["true", "false"]).transform((value) => value === "true"),
  PUBLIC_WEBAPP_URL: urlValidator,
  PUBLIC_WEBAPP_USER_ACTIVITY_PING_INTERVAL_SECONDS: z.coerce.number().int().min(1).max(3600),
  PUBLIC_SUPABASE_URL: urlValidator.optional(),
  PUBLIC_SUPABASE_PUBLISHABLE_KEY: z.string().min(1).optional(),
  PUBLIC_WEBSITE_IS_IN_MAINTENANCE_MODE: isMaintenanceModeValidation,
};

export type ClientSchemaKeys = keyof typeof clientSchema;
